import React from 'react'
import {Typography, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import Button from 'components/Button';
import Tr from 'translations/Translations';

const style = theme => {
    const width = 400;
    return {
        root: {
            marginTop: theme.spacing(2)
        },
        button: {
            width,
            height: 60,
        },
        text: {
            width,
            textAlign: 'center',
            marginTop: theme.spacing(2),
        }
    }
}

function StartScreen(
    {
        classes,
        onFormOpen,
        onImporterOpen
    }) {
    return (
        <GridBlock
            className={classes.root}
            justify="space-around"
        >
            <GridBlock column>
                <Button
                    color="primary"
                    className={classes.button}
                    onClick={onFormOpen}
                >
                    {Tr('prepare_offer_form')}
                </Button>
                <Typography
                    className={classes.text}
                >
                    {Tr('prepare_offer_form_description')}
                </Typography>
            </GridBlock>

            <GridBlock column>
                <Button
                    onClick={onImporterOpen}
                    className={classes.button}
                    color="primary"
                >
                    {Tr('import_form_more_than')}
                </Button>
                <Typography
                    className={classes.text}
                >
                    {Tr('import_form_more_than_description')}
                </Typography>
            </GridBlock>
        </GridBlock>
    )
}

StartScreen.propTypes = {
    classes: PropTypes.any,
}

export default withStyles(style)(StartScreen);